import React, { useState } from 'react';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaInstagram, FaYoutube } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
      
      // Reset success message after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000);
    }, 2000);
  };

  const contactInfo = [
    {
      icon: <FaEnvelope />,
      title: 'Email',
      details: 'chandanbs714@gmail.com',
      action: 'mailto:chandanbs714@gmail.com'
    },
    {
      icon: <FaPhoneAlt />,
      title: 'Phone',
      details: '+91 8904463526',
      action: 'tel:+918904463526'
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Location',
      details: 'India - Available Worldwide',
      action: null
    },
    {
      icon: <FaInstagram />,
      title: 'Instagram',
      details: '@chandu_arts26',
      action: 'https://instagram.com/chandu_arts26'
    },
    {
      icon: <FaYoutube />,
      title: 'YouTube',
      details: '@chandanbs8751',
      action: 'https://www.youtube.com/@chandanbs8751'
    }
  ];

  const services = [
    'Custom Portraits',
    'Family Portraits',
    'Pet Portraits',
    'Digital Illustrations',
    'Wedding Art',
    'Business Branding',
    'Other'
  ];

  return (
    <section id="contact" className="section contact">
      <div className="container">
        <div className="section-title">
          <h2>Get In Touch</h2>
          <p>Ready to create something amazing? Let's discuss your project</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Let's Start Your Project</h3>
            <p>
              I'm excited to hear about your vision and help bring it to life through art. 
              Whether you need a custom portrait, business branding, or any other creative work, 
              I'm here to make it happen.
            </p>
            
            <div className="contact-details">
              {contactInfo.map((info, index) => (
                <div key={index} className="contact-item">
                  <div className="contact-icon">{info.icon}</div>
                  <div className="contact-text">
                    <h4>{info.title}</h4>
                    {info.action ? (
                      <a href={info.action} className="contact-link">
                        {info.details}
                      </a>
                    ) : (
                      <p>{info.details}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="response-time">
              <h4>Response Time</h4>
              <p>I typically respond to all inquiries within 24 hours</p>
            </div>
          </div>

          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your full name"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+1 (555) 123-4567"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="service">Service Interested In</label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                >
                  <option value="">Select a service</option>
                  {services.map((service, index) => (
                    <option key={index} value={service}>
                      {service}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Project Details *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="Tell me about your project, timeline, and any specific requirements..."
                />
              </div>

              <button 
                type="submit" 
                className={`btn submit-btn ${isSubmitting ? 'submitting' : ''}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>

              {submitStatus === 'success' && (
                <div className="success-message">
                  <p>✅ Thank you! Your message has been sent successfully. I'll get back to you soon!</p>
                </div>
              )}
            </form>
          </div>
        </div>

        <div className="contact-cta">
          <h3>Ready to Get Started?</h3>
          <p>Don't wait - let's create something beautiful together</p>
          <div className="cta-buttons">
            <a href="mailto:chandan@artbychandan.com" className="btn">
              Email Me Directly
            </a>
            <button 
              className="btn btn-outline"
              onClick={() => document.getElementById('portfolio').scrollIntoView({ behavior: 'smooth' })}
            >
              View My Work
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
